// @givmo/board — the Form 990 instructions' rule for when minutes are contemporaneous, as Board says
// it: ONE pair, read by the Meetings page's "Writing things up" panel (`carry-forward-panel.tsx`) and
// the officer's to-do list ("About the Form 990 date"), so the two never drift (the wayfinding copy
// round's row 7.6, approved 2026-10-24 11:11 PDT).
//
// Both sentences were approved before: the board's with the panel, and the committee form in the
// committee round (CBG-YR6-MEET, 2026-10-16), said while any committee's entry is listed, because a
// committee's date counts from the committee's own next meeting (the derivation §4.4). Each names the
// rule as the instructions' rule and stops: never what happens if a date passes, never that the
// organization must do anything by it.

export const FORM_990_CONTEMPORANEOUS = {
  board:
    'The Form 990 instructions describe documentation as contemporaneous when it is prepared by the later of your next meeting or 60 days after.',
  committee:
    'The Form 990 instructions describe documentation as contemporaneous when it is prepared by the later of the next meeting of the board or committee or 60 days after.',
} as const;

/** The rule, in the form the listed entries need: the committee form once any is a committee's. */
export function form990Contemporaneous(anyCommittee: boolean): string {
  return anyCommittee ? FORM_990_CONTEMPORANEOUS.committee : FORM_990_CONTEMPORANEOUS.board;
}
